import { IImageProperties, Image, createImage } from '@vfde-brix/ws10/image';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { getCMSConfig } from '../util/cms';
import { RouterImageCmsConfig } from '../interface';

/**
 * Create Brix Image component.
 * @param {HtmlId} id - Wrapper ID of the element.
 * @returns {Image|null} Image component or null if element with given id is not found.
 */
export const mountImage = (id: HtmlId): Image | null =>
    createComponentById(createImage, id, NO_PATTERN_BUSINESS_LOGIC);

/**
 * Get image properties for component.
 * @param {RouterImageCmsConfig|undefined} cmsData - CMS config data for the product image.
 * @returns {IImageProperties} IImageProperties
 */
const getImageProps = (cmsData: RouterImageCmsConfig): IImageProperties => ({
    imgSrcDesktop: cmsData.desktopImgUrl,
    imgSrcMobile: cmsData.mobileImgUrl,
    stdTitle: cmsData.titleText,
    stdAltText: cmsData.altText,
    mediaType: 'image',
    business: NO_PATTERN_BUSINESS_LOGIC,
});

/**
 * Update Image component.
 * @param {UnorderedVerticalList|null} image - Component to update.
 * @param {string=} selectedId - Selected router product metacode.
 */
export const updateImage = (image: Image | null, selectedId?: string) => {
    if (!image || !selectedId) {
        return;
    }

    const imgConfig: RouterImageCmsConfig | undefined = getCMSConfig().routerImage[selectedId];

    if (imgConfig) {
        image.update(getImageProps(imgConfig));
    }
};
